import { BaseDataService } from "../base-services/base-data.service";
import { AsyncValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";
import { Observable, of } from "rxjs";
import { QueryParameter } from "../base-models/query-parameter";
import { UserLight } from "../base-models/user-light";
import { map } from "rxjs/operators";

export class EmailExistenceValidator {
    static createValidator(baseDataService: BaseDataService): AsyncValidatorFn {
        let asyncValidatorFn = (control: AbstractControl): Observable<ValidationErrors> => {
            let parameters: QueryParameter[] = [];
            parameters.push(new QueryParameter('username', control.value));
                let value = baseDataService.Get('user', 'userExists', parameters, null, null)
                    .pipe(
                        map((data: any) => {
                            let value = (data == null || data == false) ? null : { invalidEmail: true }
                            return value;
                        })
                    );
                return value;
        }
        return asyncValidatorFn;
    }
}